import dayjs from "dayjs";
import { getAttendanceColumns } from "./ColumnAttendance";

export const exportAttendanceCSV = async ({
  selectedMerchant,
  dateRange,
  fetchAttendance,
}) => {
  const [startDateRaw, endDateRaw] = dateRange || [];

  const startDate = startDateRaw ? dayjs(startDateRaw).startOf("day") : null;
  const endDate = endDateRaw ? dayjs(endDateRaw).endOf("day") : null;

  const formattedRange = [
    startDate ? startDate.format("YYYY-MM-DD HH:mm:ss") : null,
    endDate ? endDate.format("YYYY-MM-DD HH:mm:ss") : null,
  ];

  const data = await fetchAttendance(selectedMerchant, formattedRange, 1, 10000);
  const attendances = data.attendances || [];
  if (!attendances.length) return;

  const columns = getAttendanceColumns({ current: 1, pageSize: attendances.length });

  const headers = columns.map((col) => col.title);

  const rows = attendances.map((record, index) =>
    columns.map((col) => {
      if (col.render) {
        return `"${String(col.render(record[col.dataIndex], record, index) ?? "").replace(/"/g, '""')}"`;
      }
      return `"${String(record[col.dataIndex] ?? "").replace(/"/g, '""')}"`;
    })
  );

  const csvContent = [headers.join(","), ...rows.map((r) => r.join(","))].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  let fileName = "attendance_log";
  if (selectedMerchant) {
    fileName += `_${selectedMerchant.replace(/\s+/g, "_")}`;
  } else if (startDate || endDate) {
    const formatDate = (d) => d?.format("YYYYMMDD");
    fileName += `_${formatDate(startDate) || "start"}-${formatDate(endDate) || "end"}`;
  }
  fileName += ".csv";

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
